export const ADIntervalTime: number = 5 * 1000;
export const ADPopupHoldingTime: number = 7 * 1000;

export const ADWithdrawalIntervalTime: number = 5 * 1000;
